<template>
    <div>
        <!-- Manter Reserva -->
        <div class="modal fade" id="manterReservaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Manter Reserva de Horário</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="procedimentos && procedimentos.length">
                        <div class="alert alert-info">
                            Manter o horário reservado para outras marcações durante um período de horas, para aguardar a decisão do paciente. Esse horário não ficará disponível para outros usuários realizarem marcação.
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    label="Manter por..."
                                    v-model="horas"
                                    optionsData="id"
                                    :optionsList="horasOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    rows="3"
                                    type="textarea"
                                    label="Observação"
                                    placeholder="Observações..."
                                    v-model="observacao" />
                            </div>
                        </div>

                        <pre v-if="false">{{ procedimentos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <az-submit @click="atualizar()">Manter Reserva</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            horas: 12, 
            observacao: '',
            procedimentos: null, 
            validate: false, 
            callback: null, 
            paciente: null, 
        };
    },

    components: { AzInput, AzSubmit },

    computed: { 
        horasOptions: function () { 
            return [
                { id: '1', search: '1 Hora' },
                { id: '2', search: '2 Horas' },
                { id: '3', search: '3 Horas' },
                { id: '4', search: '4 Horas' },
                { id: '5', search: '5 Horas' },
                { id: '6', search: '6 Horas' },
                { id: '7', search: '7 Horas' },
                { id: '8', search: '8 Horas' },
                { id: '9', search: '9 Horas' },
                { id: '10', search: '10 Horas' },
                { id: '11', search: '11 Horas' },
                { id: '12', search: '12 Horas' },
                { id: '24', search: '24 Horas' },

            ]

        }
    },

    methods: { 
        fechar_modal() { 
            $('#manterReservaModal').modal('hide');
        },

        abrir(procedimentos, paciente, callback) { 
            this.callback = callback;
            this.procedimentos = _.cloneDeep(procedimentos);
            this.paciente = _.cloneDeep(paciente);
            this.horas = "12"; 
            this.observacao = "";

            $('#manterReservaModal').modal('show');
        },

        atualizar () { 
            if ( !this.horas ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Informe o período para manter a reserva.",
                    life: 3000
                }); 
                return;
            }

            let query = { 
                
                q: this.procedimentos.map(proc => { 

                    return {
                        name: 'agendas.reservar',
                        id: 'reservar',
                        parms: {
                            data: proc.data,
                            hora: proc.hora,
                            hg: proc.hg, 
                            vg: proc.vg, 
                            medico: proc.medico,
                            ordem_chegada: proc.ordem_chegada ? true : false,
                            extra: proc.extra ? true : false,
                            paciente: this.paciente,
                            plano: proc.plano,
                            procedimento: proc.procedimento,
                            ch_tipo_consulta: proc.tipo_consulta,
                            teste: proc,
                            id_unidade_operacao: proc.id_unidade_operacao,
                            id_agenda: proc.id_agenda,
                            slots: proc.slots, 
                            fixo: true, 
                            tempo_reserva: this.horas,
                            obs: this.observacao, 
                        }
                    };

                })
            };

            this.$store.commit('loading', true);

            this.axios.post('/aql?a=agendas.reservar_fixo', query)
                .then(() => { 

                    this.$toast.add({
                        severity: "success",
                        summary: "Sucesso",
                        detail: "Reserva registrada.",
                        life: 3000
                    }); 

                    $('.modal').modal('hide');

                    this.callback ();
                           
                        
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                }); 

        }

    }

}
</script>
